var map = {
	"./Figma.png": "74f8",
	"./android.png": "57bb",
	"./aws.jpg": "68a7",
	"./bootstrap.png": "0d49",
	"./c.png": "ab80",
	"./corel.png": "fc19",
	"./css.png": "5b5d",
	"./cucumber.png": "1d64",
	"./f3.png": "b409",
	"./fx.png": "4e27",
	"./heroku.png": "0293",
	"./html.png": "f5b8",
	"./java.png": "56d0",
	"./jq.png": "d3ee",
	"./js.png": "21ce",
	"./materialize.png": "fdf9",
	"./mysql.png": "4059",
	"./net.png": "6b47",
	"./node.png": "3282",
	"./photoshop.png": "4946",
	"./php.png": "2204",
	"./psql.png": "8ee2",
	"./react.png": "b0c9",
	"./sass.png": "c27a",
	"./selenium-logo.png": "94e1",
	"./solidworks-logo.png": "a53d",
	"./spring.png": "01a7",
	"./swagger.png": "9059",
	"./vue.png": "dfc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22d1";